import { render } from "./DailyMenuPage.vue?vue&type=template&id=35cacf06&scoped=true"
import script from "./DailyMenuPage.vue?vue&type=script&lang=js"
export * from "./DailyMenuPage.vue?vue&type=script&lang=js"

import "./DailyMenuPage.vue?vue&type=style&index=0&id=35cacf06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cacf06"]])

export default __exports__